import { render, staticRenderFns } from "./ClientPricePlanInfo.vue?vue&type=template&id=774a923a&"
import script from "./ClientPricePlanInfo.vue?vue&type=script&lang=ts&"
export * from "./ClientPricePlanInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLinearProgress} from 'quasar'
component.options.components = Object.assign({QLinearProgress}, component.options.components || {})
